export const loginActions = {
  setMsalInstance(payload) {
    this.msalInstance = payload
  },
  setAuthenticated(payload) {
    this.isAuthenticated = payload
  },
  setIsInitialized(payload) {
    this.isInitialized = payload
  },
  setIsLoggedIn(payload) {
    this.isLoggedIn = payload
  },
  setUserName(payload) {
    this.userName = payload
  },
  setUserEmail(payload) {
    this.userEmail = payload
  },
  setLoginType(payload) {
    this.loginType = payload
  },
  setMicrosoftLogin(payload) {
    localStorage.setItem('microsoftLogin', payload)
    this.microsoftLogin = payload
  },
  setMicrosoftLogout() {
    localStorage.setItem('microsoftLogout')
    this.microsoftLogin = {}
  },
  setGoogleLogin(payload) {
    localStorage.setItem('googleLogin', payload)
    this.googleLogin = payload
  },
  setAdminuserInfo(payload) {
    this.adminuserInfo = payload
  },
  setInteractionInProgress(payload) {
    this.interactionInProgress = payload
  },
  setAccessToken(payload) {
    this.accesstoken = payload
  },
  setIdToken(payload) {
    this.idtoken = payload
  },
  logIsLoggedIn(payload) {
    console.log('LOGINSTORE: logIsLoggedIn called with payload:', payload)
    /*
    @TODO implement functionality, copy from PROCLUS project... 
    */
  }
}
